import { Navigate, Outlet } from 'react-router';

import type { Permission } from '@/constants/permissions';
import { useAuth } from '@/features/auth/hooks/useAuth';

export interface RequirePermissionProps {
  permissions: Permission[];
}

/**
 * Route-level authorization guard, distinct from `ProtectedRoute`
 * (authentication only). Compose them in the router as nested routes:
 * `ProtectedRoute > RequirePermission > page`.
 */
export function RequirePermission({ permissions }: RequirePermissionProps) {
  const { hasPermission } = useAuth();

  if (!hasPermission(permissions)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
